<template>
	<Layout header-class="header-left-align" nav-alignment="left" :topbar-style="2">
		<!-- Start Slider area -->
		<div class="slider-area slider-style-2 variation-2 height-450 bg_image"
				 :style="{'background-image': `url(${require(`@/assets/images/banner-ai.png`)})`}">
			<div class="container">
				<h2 class="w-600 title text-left color-white mb--0 banner-text">企業級一站式GenAI平台</h2>
			</div>
		</div>

		<div class="rwt-advance-tab-area rn-section-gap sbg" data-aos="fade-up" data-aos-delay="100">
			<div class="container">
				<h2 class="w-600 title text-center" style="font-size: 32px">企業級一站式GenAI平台</h2>
				<div style="margin-top: 48px; ">
						<p style="font-size: 18px">
							提供企業級GenAI全棧私有化平台產品，從數據採集、清洗標註到模型訓練、推理部署，實現企業私域數據"輸入-處理-輸出"全生命週期管理，支援RAG增強與知識圖譜構建，確保領域知識精準注入，實現端到端數據閉環體系。同時內置國密SM4/SM9算法，通過記憶體隔離（SGX）與量子加密傳輸，滿足等保2.0/3.0及金融/醫療級數據安全要求。
						</p>
				</div>
			</div>
		</div>

		<div class="rwt-advance-tab-area rn-section-gap" data-aos="fade-up" data-aos-delay="100">
			<div class="container">
				<h2 class="w-600 title text-center" style="font-size: 32px">核心功能</h2>
				<div class="product product-r">
					<div class="txt" >
						<div class="swiper-container">
							<div class="swiper-wrapper">
								<div class="swiper-slide">
									<div class="eee">
									<div class="t1">全域模型調度中樞</div>
									<div class="t2">
										百模互聯生態：集成Llama3、DeepSeek-R1、Qwen1.5等40+開源模型，支援動態加載與熱切換；通過MoE架構實現模型並行調度，提升GPU利用率<br>
										異構算力優化：基於動態量化（FP8/INT4）與晶片感知調度算法，自動匹配模型與硬件（如NVIDIA GPU/華為昇騰），降低推理延遲，支援千億模型單卡部署
									</div>
									</div>
								</div>
								<div class="swiper-slide">
									<div class="eee">
									<div class="t1">企業知識治理引擎</div>
									<div class="t2">
										多模態知識融合：支援PDF/Word/數據庫非結構化數據解析，結合OCR+NLP實現95%+準確率的向量化存儲；通過圖神經網絡（GNN）構建可溯源的領域知識圖譜<br>
										智能檢索增強：採用Graph-enhanced RAG技術，融合語義檢索與圖關係推理，解決"合同條款跨文檔追溯""技術標準聯動查詢"等複雜場景
									</div>
									</div>
								</div>
								<div class="swiper-slide">
									<div class="eee">
									<div class="t1">零代碼AI生產鏈</div>
									<div class="t2">
										場景化模板庫：預置智能客服、財報分析等50+行業模板，拖拽式工作流設計器支援多節點編排（如"數據輸入→模型推理→結果校驗"），應用搭建週期從周級縮短至小時級<br>
										多智能體協同：基於PRC架構（Planning-Reflection-Collaboration）實現跨系統任務自動化，例如供應鏈異常檢測中聯動ERP、物流系統，提升預警響應速度
									</div>
									</div>
								</div>
								<div class="swiper-slide">
									<div class="eee">
										<div class="t1">安全合規基座</div>
										<div class="t2">
											數據全鏈路閉環：通過SGX加密記憶體與量子傳輸加密，確保訓練/推理數據不出本地域；支援敏感字段自動脫敏（如身份證號、醫療記錄），洩露風險歸零<br>
											合規性增強：內置金融級審計日誌與RBAC權限體系，滿足等保3.0/GDPR要求；實時內容過濾模組攔截違規輸出
										</div>
									</div>
								</div>
							</div>
							<div class="swiper-pagination"></div>
						</div>
					</div>
					<div class="pic">
						<img src="@/assets/images/genai1.png" style="border-radius: 12px;">
					</div>
				</div>
			</div>
		</div>

		<Separator />

		<div class="rwt-advance-tab-area rn-section-gap" data-aos="fade-up" data-aos-delay="100">
			<div class="container">
				<h2 class="w-600 title text-center" style="font-size: 32px">應用場景</h2>
				<div class="product">
					<div class="pic">
						<img src="@/assets/images/genai2.png" style="border-radius: 12px;">
					</div>
					<div class="txt" >
						<div class="swiper-container">
							<div class="swiper-wrapper">
								<div class="swiper-slide">
									<div class="eee">
										<div class="t1">智能決策中樞</div>
										<div class="t2">
											多源數據融合引擎：整合業務數據（如ERP、CRM）與行業知識庫（如政策法規、市場報告），通過RAG增強與圖神經網絡（GNN）構建動態知識圖譜，生成趨勢預測與風險評估報告<br>
											實時決策支援：基於DeepSeek大模型的推理能力，自動識別供應鏈中斷風險（如港口擁堵），推薦優化方案
										</div>
									</div>
								</div>
								<div class="swiper-slide">
									<div class="eee">
										<div class="t1">全流程自動化工廠</div>
										<div class="t2">
											RPA+AI協同：訂單處理，通過OCR+NLP自動解析異構單據（如Excel/PDF）；合規審查，集成Legal-BERT模型掃描合同條款，覆蓋風險點識別，減少人工複核時間<br>
											動態資源調度：AI驅動供應鏈排程，結合實時物流數據優化庫存週轉
										</div>
									</div>
								</div>
								<div class="swiper-slide">
									<div class="eee">
									<div class="t1">客戶交互智能體</div>
									<div class="t2">
										多模態客服系統：支援Word/PDF/圖片解析，構建可溯源的FAQ庫；基於騰訊雲大模型實現擬人化應答，提升客戶滿意度<br>
										個性化推薦：通過用戶行為分析生成定制化方案（如金融產品匹配），提高轉化率
									</div>
									</div>
								</div>
								<div class="swiper-slide">
									<div class="eee">
									<div class="t1">生產與知識協同網絡</div>
									<div class="t2">
										物聯網優化：傳感器數據訓練LSTM模型，提高設備故障預警準確率，減少停機時間<br>
										員工智能助手：基於向量數據庫秒級定位技術文檔，縮短信息獲取時間；語音轉寫+大模型摘要，自動生成會議紀要
									</div>
									</div>
								</div>
							</div>
							<div class="swiper-pagination"></div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</Layout>
</template>

<script>
import Layout from '@/components/common/Layout'
import Separator from '@/components/elements/separator/Separator'
import Swiper from "swiper";
import "swiper/css/swiper.css";
export default {
	name: 'Solution1',
	components: {Separator, Layout},
	data() {
		return {

		}
	},
	mounted() {
		new Swiper(".swiper-container", {
			autoplay: true,
			delay: 2000,
			pagination: {
				el: ".swiper-pagination",
				clickable: true,
				renderBullet: function (index, className) {
					return '<span class="' + className + '">' + (index + 1) + "</span>";
				},
			},
		});
	}
}
</script>
<style lang="scss" scoped>
.sbg {
	background-image: url("../../../assets/images/sbg.jpg");
}
.product {
	margin-top: 72px;
	display: flex;
	.pic {
		width: 40%;
		img {
			width: 100%;
		}
	}
	.txt {
		width: 60%;
		.eee {
			width: 90%;
			text-align: left;
			.t1 {
				font-size: 24px;
				font-weight: 600;
				color: #000;
			}
			.t2 {
				margin-top: 12px;
				color: #000;
			}
		}
	}
}
@media only screen and (max-width: 768px) {
	.product {
		flex-direction: column;
		gap: 20px;
		.pic {
			width: 100%;
		}
		.txt {
			width: 100%;
		}

		&.product-r {
			flex-direction: column-reverse;
		}
	}
}
.swiper-container {
	width: 100%;
	.swiper-wrapper {
		width: 100%;
	}
	.swiper-slide {
		width: 100%;
		text-align: center;
		font-size: 18px;
		background: #fff;
		display: flex;
		justify-content: center;
		align-items: center;
	}
	:deep(.swiper-pagination) {
		bottom: 30px;
		position: unset;
	}

	:deep(.swiper-pagination-bullet) {
		width: 20px;
		height: 20px;
		text-align: center;
		line-height: 20px;
		font-size: 12px;
		color: #000;
		opacity: 1;
		background: rgba(0, 0, 0, 0.2);
	}

	:deep(.swiper-pagination-bullet-active){
		color: #fff;
		background: #007aff;
	}
}
.banner-text {
	text-shadow:
		0 0 2px black,
		0 0 2px black,
		0 0 2px black,
		0 0 2px black;
}
</style>
